import type { SVGProps } from 'react';
const SvgHouseSiding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#house_siding_svg__a)">
      <path
        fill="currentColor"
        d="M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8ZM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19Zm7.36-2H9.43L12 5.69 14.57 8ZM7 16v-2h10v2H7Z"
      />
    </g>
    <defs>
      <clipPath id="house_siding_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHouseSiding;
